/*
 * <kremi-ugc-stories> — UGC hikâye daireleri + Instagram benzeri story görüntüleyici (10-03).
 *
 * DAİRE: video yalnız daire GÖRÜNÜR olunca (IntersectionObserver, eşik %25) src alır ve sessiz döngüde
 * oynar; görünümden çıkınca durur. Ortak kremi-lazy-video bilinçli KULLANILMAZ — o bir ekran boyu önceden
 * yükler, mobilde blok ilk ekrana yakın olduğundan sayfa açılışında videolar inerdi (10-01 ölçümü).
 *
 * GÖRÜNTÜLEYİCİ (Zeynep 10-03): daireye dokununca tam ekran açılır.
 *  - Video SESSİZ (muted, ses düğmesi yok), durdurulabilir: videoya tıklama · boşluk · basılı tutma (mobil).
 *    Ayrı durdur/oynat düğmesi YOK (Zeynep 10-03); durakken ortada soluk oynat işareti.
 *  - Üstte ilerleme çubukları; video bitince sonraki hikâye, sonuncusu bitince kapanır.
 *  - Gezinme: ←/→ düğmeleri ve tuşları · mobilde ekranın sol/sağ kenarına dokunma · Esc kapatır.
 *  - Videodaki ürünler (10-03 ikinci tur): masaüstünde sağ panelde ürün kartları (tek ürün büyük kart,
 *    birden fazlası iki sütun), mobil/tablette videonun ALTINDA ana sayfa UGC kartıyla aynı beyaz kutu.
 *    Eylemler: Hızlı satın al (ekler → ödeme; sepeti temizlemez) · Sepete ekle · görsel üstünde favori.
 *    Köşeler düz — sitede yuvarlak köşe kullanılmıyor.
 *    Sepete ekleme temanın kendi akışıyla (cart/add.js + variant:add + cart:change) → sepet çekmecesi
 *    açılır ve güncellenir; çekmece (z 1001) görüntüleyicinin (z 1000) üstünde açılır, video durur.
 *  - Tam ekran videonun kaynağı ekran yüksekliğine göre seçilir; yalnız açılınca yüklenir.
 * Veri: blok içindeki <script data-story-data> (kremi-ugc-stories.liquid).
 */
(() => {
  if (window.customElements.get('kremi-ugc-stories')) return;

  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const readJson = (root, sel, fallback) => {
    try {
      return JSON.parse(root.querySelector(sel)?.textContent || '') ?? fallback;
    } catch (e) {
      return fallback;
    }
  };
  const pickSource = (sources, needH) => {
    const list = (sources || []).filter((s) => s && s.u).sort((a, b) => (a.h || a.w) - (b.h || b.w));
    return (list.find((s) => (s.h || s.w) >= needH) || list[list.length - 1] || {}).u || '';
  };

  /* ───────────────────────── Görüntüleyici (sayfada tek örnek) ───────────────────────── */
  const ICON_PREV = '<svg aria-hidden="true" focusable="false" fill="none" width="10" viewBox="0 0 10 10"><path d="M7 1 3 5l4 4" stroke="currentColor" stroke-linecap="square"/></svg>';
  const ICON_NEXT = '<svg aria-hidden="true" focusable="false" fill="none" width="10" viewBox="0 0 10 10"><path d="m3 9 4-4-4-4" stroke="currentColor" stroke-linecap="square"/></svg>';
  // Temanın 'close' ikonu (snippets/icon.liquid) — ince ✕, çerçevesiz (10-03: dolgulu daire 'çok sert'ti).
  const ICON_CLOSE = '<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.25"/></svg>';
  const ICON_HEART = '<svg class="kremi-wish__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3 4.6 13a4.6 4.6 0 0 1 0-6.5 4.6 4.6 0 0 1 6.5 0l.9.9.9-.9a4.6 4.6 0 0 1 6.5 0 4.6 4.6 0 0 1 0 6.5Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';

  class StoryViewer {
    static DECK_MS = 4000; // ana sayfa UGC deck'iyle aynı dönüş süresi

    constructor() {
      this.el = document.createElement('div');
      this.el.className = 'kremi-story-viewer';
      this.el.hidden = true;
      this.el.setAttribute('role', 'dialog');
      this.el.setAttribute('aria-modal', 'true');
      this.el.innerHTML = `
        <div class="kremi-story-viewer__backdrop" data-close></div>
        <button type="button" class="kremi-story-viewer__close" data-close>${ICON_CLOSE}</button>
        <button type="button" class="kremi-story-viewer__nav kremi-story-viewer__nav--prev circle-button hover:animate-icon-inline" data-prev>${ICON_PREV}</button>
        <div class="kremi-story-viewer__stage">
          <div class="kremi-story-viewer__frame">
            <div class="kremi-story-viewer__bars"></div>
            <video class="kremi-story-viewer__video" muted playsinline preload="auto"></video>
            <span class="kremi-story-viewer__paused" aria-hidden="true"><span class="kremi-story-viewer__icon kremi-story-viewer__icon--play"></span></span>
            <div class="kremi-story-viewer__tap kremi-story-viewer__tap--prev" data-tap-prev></div>
            <div class="kremi-story-viewer__tap kremi-story-viewer__tap--next" data-tap-next></div>
          </div>
          <aside class="kremi-story-viewer__panel">
            <p class="kremi-story-viewer__panel-title"></p>
            <div class="kremi-story-viewer__products"></div>
            <div class="kremi-story-viewer__deck-bars"></div>
          </aside>
        </div>
        <button type="button" class="kremi-story-viewer__nav kremi-story-viewer__nav--next circle-button hover:animate-icon-inline" data-next>${ICON_NEXT}</button>`;
      document.body.appendChild(this.el);
      this.video = this.el.querySelector('video');
      this.video.muted = true;
      this.video.volume = 0;
      this.bars = this.el.querySelector('.kremi-story-viewer__bars');
      this.panel = this.el.querySelector('.kremi-story-viewer__panel');
      this.products = this.el.querySelector('.kremi-story-viewer__products');
      this.deckBars = this.el.querySelector('.kremi-story-viewer__deck-bars');
      this.mobileQuery = window.matchMedia('(max-width: 999px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Mobil ürün destesi (10-03, Zeynep): ana sayfa UGC kartındaki gibi alt kenarda dolan çizgiler;
      // 4 sn'de bir sonraki ürün, çizgiye dokununca o ürün, kartta yana kaydırınca komşu ürün. Ok YOK
      // (Zeynep: 'ekranda çok ok oldu'). İmleç/parmak/odak paneldeyken DURUR — "Sepete ekle"ye basarken
      // ürün altından değişmesin (ana sayfa deck'iyle aynı kural).
      let cardSwipe = null;
      this.panel.addEventListener('pointerdown', (e) => {
        cardSwipe = e.pointerType === 'touch' && this.cards.length > 1 && this.mobileQuery.matches ? { x: e.clientX, y: e.clientY } : null;
      });
      this.panel.addEventListener('pointerup', (e) => {
        if (!cardSwipe) return;
        const dx = e.clientX - cardSwipe.x;
        const dy = e.clientY - cardSwipe.y;
        cardSwipe = null;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        this.showProduct(this.deckIndex + (dx < 0 ? 1 : -1));
        this.restartDeck();
      });
      this.deckBars.addEventListener('click', (e) => {
        const bar = e.target.closest('[data-bar]');
        if (!bar) return;
        this.showProduct(Number(bar.dataset.bar));
        this.restartDeck();
      });
      this.panel.addEventListener('pointerenter', () => this.pauseDeck());
      this.panel.addEventListener('pointerleave', () => this.resumeDeck());
      this.panel.addEventListener('focusin', () => this.pauseDeck());
      this.panel.addEventListener('focusout', () => this.resumeDeck());
      this.mobileQuery.addEventListener?.('change', () => this.restartDeck());

      this.el.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.el.querySelector('[data-prev]').addEventListener('click', () => this.go(-1));
      this.el.querySelector('[data-next]').addEventListener('click', () => this.go(1));
      this.el.querySelector('[data-tap-prev]').addEventListener('click', () => this.go(-1));
      this.el.querySelector('[data-tap-next]').addEventListener('click', () => this.go(1));
      this.video.addEventListener('click', () => this.togglePause());
      this.video.addEventListener('ended', () => this.go(1, true));
      // İlerleme çizgisi her karede (rAF) güncellenir: timeupdate saniyede ~3-4 kez gelir, çizgi
      // ~280 ms'lik basamaklarla zıplıyordu (Zeynep 10-03: 'gezerken takılma'). timeupdate yedek kalır.
      this.video.addEventListener('timeupdate', () => this.progress());
      this.video.addEventListener('playing', () => this.tick());
      // Yatay video (ör. Lip Balm) her ekranda tam görünür; dikey videolar mobilde ekranı doldurur.
      this.video.addEventListener('loadedmetadata', () => {
        this.el.classList.toggle('is-landscape', this.video.videoWidth > this.video.videoHeight);
      });
      this.video.addEventListener('volumechange', () => {
        if (!this.video.muted || this.video.volume) {
          this.video.muted = true; // ses hep kapalı (Zeynep 10-03)
          this.video.volume = 0;
        }
      });

      // Mobil (Instagram akışı): tek dokunuş hikâye değiştirir (tap alanları, CSS), basılı tutunca durur,
      // bırakınca devam eder; yana kaydırma da hikâye değiştirir. Masaüstünde videoya tıklamak durdurur.
      const frame = this.el.querySelector('.kremi-story-viewer__frame');
      let holdTimer = null;
      let swipe = null;
      frame.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'touch' || e.target.closest('button, a, .kremi-story-viewer__panel')) return;
        swipe = { x: e.clientX, y: e.clientY };
        holdTimer = setTimeout(() => {
          this.held = true;
          this.video.pause();
        }, 220);
      });
      // Yana kaydırma (≥50px, yatay baskın) → önceki/sonraki hikâye.
      frame.addEventListener('pointerup', (e) => {
        if (!swipe) return;
        const dx = e.clientX - swipe.x;
        const dy = e.clientY - swipe.y;
        swipe = null;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        clearTimeout(holdTimer);
        this.held = false;
        this.swallowTap = true;
        setTimeout(() => (this.swallowTap = false), 350);
        this.go(dx < 0 ? 1 : -1);
      });
      frame.addEventListener('pointercancel', () => (swipe = null));
      const release = () => {
        clearTimeout(holdTimer);
        if (this.held) {
          this.held = false;
          if (!this.userPaused) this.video.play().catch(() => {});
          this.swallowTap = true; // basılı tutma "dokunma" sayılıp hikâye değiştirmesin
          setTimeout(() => (this.swallowTap = false), 50);
        }
      };
      frame.addEventListener('pointerup', release);
      frame.addEventListener('pointercancel', release);
      frame.addEventListener('click', (e) => {
        if (this.swallowTap) {
          e.stopPropagation();
          e.preventDefault();
        }
      }, true);

      this.onKey = (e) => {
        if (this.el.hidden) return;
        if (e.key === 'Escape') this.close();
        else if (e.key === 'ArrowRight') this.go(1);
        else if (e.key === 'ArrowLeft') this.go(-1);
        else if (e.key === ' ' && !e.target.closest('button, a, input')) {
          e.preventDefault();
          this.togglePause();
        }
      };
      document.addEventListener('keydown', this.onKey);
      // Sepet çekmecesi açılınca video dursun.
      document.addEventListener('cart:change', () => {
        if (!this.el.hidden) this.pause(true);
      });
    }

    setStrings(s) {
      this.s = s;
      this.el.setAttribute('aria-label', s.dialog || '');
      const close = this.el.querySelector('.kremi-story-viewer__close');
      close.setAttribute('aria-label', s.close || '');
      this.el.querySelector('[data-prev]').setAttribute('aria-label', s.prev || '');
      this.el.querySelector('[data-next]').setAttribute('aria-label', s.next || '');
      this.el.querySelector('.kremi-story-viewer__panel-title').textContent = s.productsTitle || '';
    }

    open(owner, stories, strings, index) {
      this.owner = owner;
      this.stories = stories;
      this.setStrings(strings);
      this.returnFocus = document.activeElement;
      this.bars.innerHTML = stories.map(() => '<span><i></i></span>').join('');
      this.el.hidden = false;
      document.documentElement.classList.add('kremi-story-open');
      owner.pauseBubbles();
      requestAnimationFrame(() => this.el.classList.add('is-open'));
      this.show(index);
      // Odak klavye kullanıcısı için kapat düğmesine; fareyle açılışta halka görünmesin.
      this.el.querySelector('.kremi-story-viewer__close').focus({ preventScroll: true, focusVisible: false });
    }

    close() {
      if (this.el.hidden) return;
      clearTimeout(this.deckTimer);
      cancelAnimationFrame(this.rafId);
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
      this.el.classList.remove('is-open');
      this.el.hidden = true;
      document.documentElement.classList.remove('kremi-story-open');
      this.owner?.resumeBubbles();
      this.returnFocus?.focus?.({ preventScroll: true });
    }

    go(step, fromEnd) {
      const next = this.index + step;
      if (next < 0) {
        this.video.currentTime = 0;
        return;
      }
      if (next >= this.stories.length) {
        if (fromEnd) this.close();
        return;
      }
      this.show(next);
    }

    show(index) {
      this.index = index;
      const story = this.stories[index];
      [...this.bars.children].forEach((bar, i) => {
        bar.querySelector('i').style.transform = i < index ? 'scaleX(1)' : 'scaleX(0)';
      });
      this.el.querySelector('[data-prev]').disabled = index === 0;
      this.el.querySelector('[data-next]').disabled = index === this.stories.length - 1;
      const frame = this.el.querySelector('.kremi-story-viewer__frame');
      let needH = Math.ceil((frame.getBoundingClientRect().height || window.innerHeight) * Math.min(window.devicePixelRatio || 1, 2));
      if (window.innerWidth < 700) needH = Math.min(needH, 720); // telefonda 720p yeter, veri ~yarı yarıya
      // Yön, video yüklenmeden kaynak ölçülerinden bilinir — eskiden loadedmetadata'yı bekliyordu ve
      // yatay↔dikey geçişte yeni video bir an öncekinin kadrajıyla (cover/contain) görünüp sıçrıyordu.
      const dims = (story.sources || []).find((x) => x && x.w && x.h);
      if (dims) this.el.classList.toggle('is-landscape', dims.w > dims.h);
      this.video.poster = story.poster || '';
      this.video.src = pickSource(story.sources, needH);
      // Sonraki hikâyenin kapak karesi önceden insin: geçişte siyah kare yerine hemen kapak görünür.
      const upcoming = this.stories[index + 1];
      if (upcoming?.poster) new Image().src = upcoming.poster;
      this.userPaused = false;
      this.play();
      this.renderProducts(story);
    }

    tick() {
      cancelAnimationFrame(this.rafId);
      const step = () => {
        this.progress();
        if (!this.video.paused && !this.video.ended && !this.el.hidden) this.rafId = requestAnimationFrame(step);
      };
      this.rafId = requestAnimationFrame(step);
    }

    progress() {
      const bar = this.bars.children[this.index];
      if (!bar || !this.video.duration) return;
      bar.querySelector('i').style.transform = `scaleX(${Math.min(1, this.video.currentTime / this.video.duration)})`;
    }

    play() {
      this.video.muted = true;
      this.video.play().catch(() => {});
      this.el.classList.remove('is-paused');
    }

    pause(byUser) {
      if (byUser) this.userPaused = true;
      this.video.pause();
      this.el.classList.add('is-paused');
    }

    togglePause() {
      if (this.video.paused) {
        this.userPaused = false;
        this.play();
      } else {
        this.pause(true);
      }
    }

    /* ── Ürün kartları (10-03 ikinci tur): sitedeki ürün kartı / ana sayfa UGC kartı dili ──
       Masaüstü: sağ panel — her ürün (tek de olsa) tam genişlikte yatay satır kartı, dikeyde ortalı.
       Tek ürün için büyük kart 4:5 görselle paneli dolduruyordu (Zeynep 10-03: 'diğer hali çok iyiydi').
       Mobil/tablet: videonun ALTINDA, ana sayfadaki UGC kartıyla aynı beyaz kutu (yatay kayar).
       Eylemler: [Hızlı satın al] [Sepete ekle] + görsel üstünde favori kalbi. */
    renderProducts(story) {
      const list = story.products || [];
      this.el.classList.toggle('has-products', list.length > 0);
      this.products.classList.toggle('is-grid', list.length > 0);
      const hint = (story.title || '').toLocaleLowerCase('tr');
      const s = this.s;
      this.products.innerHTML = list
        .map((p, pi) => {
          const variants = p.variants || [];
          let sel = variants.findIndex((v) => v.available && hint && v.title.toLocaleLowerCase('tr').includes(hint));
          if (sel < 0) sel = Math.max(0, variants.findIndex((v) => v.available));
          const v0 = variants[sel] || {};
          const swatches = p.single
            ? ''
            : `<div class="kremi-story-card__swatches" role="radiogroup" aria-label="${esc(p.title)}">${variants
                .map((v, vi) => {
                  const bg = v.swatch ? `background-image:url('${esc(v.swatch)}')` : v.color ? `background:${esc(v.color)}` : '';
                  const cls = `kremi-story-card__swatch${bg ? '' : ' kremi-story-card__swatch--text'}${v.available ? '' : ' is-soldout'}`;
                  return `<button type="button" class="${cls}" role="radio" aria-checked="false" aria-label="${esc(v.title)}" title="${esc(v.title)}" data-vi="${vi}" style="${bg}">${bg ? '' : esc(v.title)}</button>`;
                })
                .join('')}</div>`;
          return `
            <div class="kremi-story-card" data-pi="${pi}" data-sel="${sel}">
              <div class="kremi-story-card__figure">
                <a class="kremi-story-card__media" href="${esc(v0.url || p.url)}" tabindex="-1"><img src="${esc(v0.image || p.image)}" alt="${esc(p.title)}" loading="lazy"></a>
                <span class="product-card kremi-story-card__wish">
                  <input type="radio" data-variant-id="${v0.id || ''}" checked hidden tabindex="-1" aria-hidden="true">
                  <button type="button" class="kremi-wish kremi-wish--story" data-kremi-wish data-gid="gid://shopify/Product/${p.id}" data-handle="${esc(p.handle)}"
                    data-variant-id-default="${v0.id || ''}" data-label-off="${esc(s.wishAdd)}" data-label-on="${esc(s.wishRemove)}" aria-pressed="false" aria-label="${esc(s.wishAdd)}" hidden>${ICON_HEART}</button>
                </span>
              </div>
              <div class="kremi-story-card__body">
                <p class="kremi-story-card__variant">${p.single ? '&nbsp;' : '<span class="kremi-story-card__dot"></span><span class="kremi-story-card__variant-label" lang="en"></span>'}</p>
                <div class="kremi-story-card__name-row">
                  <a class="kremi-story-card__title" href="${esc(v0.url || p.url)}">${esc(p.title)}</a>
                  <p class="kremi-story-card__price"></p>
                </div>
                ${swatches}
              </div>
              <div class="kremi-story-card__actions">
                <button type="button" class="button button--sm button--outline button--subdued kremi-story-card__buy" data-buy>${esc(s.buyNow)}</button>
                <button type="button" class="button button--sm kremi-story-card__add" data-add></button>
              </div>
              <a class="kremi-story-card__more link text-sm" href="${esc(v0.url || p.url)}">${esc(s.viewProduct)}</a>
            </div>`;
        })
        .join('');
      // Yeni kartlarda scroll-snap (mobil şerit) Chrome'da ilk açılışta SONDAKİ karta yapışıyordu
      // (ölçüldü: scrollLeft 284/304) → kartlar yerleşince açıkça başa al.
      const toStart = () => {
        this.products.scrollLeft = 0;
        this.products.scrollTop = 0;
      };
      toStart();
      requestAnimationFrame(() => requestAnimationFrame(toStart));
      this.products.querySelectorAll('.kremi-story-card').forEach((card) => {
        const p = list[Number(card.dataset.pi)];
        this.syncCard(card, p);
        card.querySelectorAll('[data-vi]').forEach((b) =>
          b.addEventListener('click', () => {
            card.dataset.sel = b.dataset.vi;
            this.syncCard(card, p);
          }),
        );
        card.querySelector('[data-add]').addEventListener('click', (e) => this.addToCart(card, p, e.currentTarget));
        card.querySelector('[data-buy]').addEventListener('click', (e) => this.buyNow(card, p, e.currentTarget));
      });
      this.cards = [...this.products.querySelectorAll('.kremi-story-card')];
      this.deckBars.innerHTML = this.cards
        .map((c, i) => `<button type="button" class="kremi-story-viewer__deck-bar" data-bar="${i}"><span class="sr-only">${esc(list[i].title)}</span></button>`)
        .join('');
      this.el.classList.toggle('has-deck', this.cards.length > 1);
      this.deckPaused = false;
      this.showProduct(0);
      this.restartDeck();
    }

    /* ── Mobil ürün destesi ── */
    showProduct(i) {
      const n = (this.cards || []).length;
      if (!n) return;
      this.deckIndex = (i + n) % n;
      this.cards.forEach((c, k) => {
        const on = k === this.deckIndex;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-hidden', String(!on && this.mobileQuery.matches));
        c.inert = !on && this.mobileQuery.matches; // gizli kartın düğmeleri sekmede/ekran okuyucuda olmasın
      });
      [...this.deckBars.children].forEach((b, k) => {
        b.classList.toggle('is-done', k < this.deckIndex);
        b.classList.remove('is-active');
        b.setAttribute('aria-current', String(k === this.deckIndex));
      });
      const active = this.deckBars.children[this.deckIndex];
      if (active) {
        void active.offsetWidth; // animasyonu baştan başlat
        active.classList.add('is-active');
      }
    }

    restartDeck() {
      clearTimeout(this.deckTimer);
      const n = (this.cards || []).length;
      if (!this.mobileQuery.matches) {
        (this.cards || []).forEach((c) => {
          c.inert = false;
          c.removeAttribute('aria-hidden');
        });
        return;
      }
      if (n < 2 || this.deckPaused || this.reducedMotion || this.el.hidden) return;
      this.el.style.setProperty('--kremi-story-deck-ms', StoryViewer.DECK_MS + 'ms');
      this.deckTimer = setTimeout(() => {
        this.showProduct(this.deckIndex + 1);
        this.restartDeck();
      }, StoryViewer.DECK_MS);
    }

    pauseDeck() {
      this.deckPaused = true;
      clearTimeout(this.deckTimer);
      this.el.classList.add('is-deck-paused');
    }

    resumeDeck() {
      this.deckPaused = false;
      this.el.classList.remove('is-deck-paused');
      this.showProduct(this.deckIndex); // çizgi baştan dolar, zamanlayıcıyla aynı hizada
      this.restartDeck();
    }

    syncCard(card, p) {
      const v = p.variants[Number(card.dataset.sel)] || p.variants[0];
      card.querySelectorAll('[data-vi]').forEach((b) => {
        const on = b.dataset.vi === card.dataset.sel;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on);
      });
      card.querySelector('.kremi-story-card__price').innerHTML =
        `<span>${esc(v.price)}</span>` + (v.compare ? ` <s>${esc(v.compare)}</s>` : '');
      const label = card.querySelector('.kremi-story-card__variant-label');
      if (label) label.textContent = v.title;
      const dot = card.querySelector('.kremi-story-card__dot');
      if (dot) {
        dot.style.cssText = v.swatch ? `background-image:url('${v.swatch}')` : v.color ? `background:${v.color}` : '';
        dot.hidden = !(v.swatch || v.color);
      }
      const img = card.querySelector('.kremi-story-card__media img');
      if (v.image) img.src = v.image;
      card.querySelectorAll('.kremi-story-card__media, .kremi-story-card__title, .kremi-story-card__more').forEach((a) => (a.href = v.url || p.url));
      const add = card.querySelector('[data-add]');
      const buy = card.querySelector('[data-buy]');
      add.disabled = buy.disabled = !v.available;
      add.textContent = v.available ? this.s.addToCart : this.s.soldOut;
      buy.hidden = !v.available;
      card.querySelector('.kremi-story-card__actions').classList.toggle('is-single-action', !v.available);
      // Favori kalbi seçili varyantı kaydetsin (kremi-wishlist.js .product-card içindeki seçili radioyu okur)
      const radio = card.querySelector('.kremi-story-card__wish input');
      const heart = card.querySelector('[data-kremi-wish]');
      if (radio && radio.getAttribute('data-variant-id') !== String(v.id)) {
        radio.setAttribute('data-variant-id', v.id);
        heart?.setAttribute('data-variant-id-default', v.id);
        radio.dispatchEvent(new Event('change', { bubbles: true })); // kalbi yeni varyanta göre boya
      }
    }

    async postAdd(v) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      // Temanın ProductForm akışının aynısı (theme.js onSubmit_fn) — çekmece kendini günceller/açar.
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const body = new FormData();
      body.set('id', v.id);
      body.set('quantity', '1');
      body.set('sections', sections.join(','));
      body.set('sections_url', `${root}variants/${v.id}`);
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', body, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || '');
      return { root, json };
    }

    async addToCart(card, p, btn) {
      const v = p.variants[Number(card.dataset.sel)];
      if (!v || !v.available || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      try {
        const { root, json } = await this.postAdd(v);
        const cart = await (await fetch(`${root}cart.js`)).json();
        cart.sections = json.sections;
        btn.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [json], cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
        btn.textContent = this.s.added;
        setTimeout(() => this.syncCard(card, p), 2200);
      } catch (e) {
        btn.textContent = e.message || this.s.error;
        setTimeout(() => this.syncCard(card, p), 3000);
      } finally {
        btn.removeAttribute('aria-busy');
      }
    }

    /** Hızlı satın al: ana sayfa UGC kartındaki <kremi-buy-now> ile aynı — ekler, ödemeye gider, sepeti TEMİZLEMEZ. */
    async buyNow(card, p, btn) {
      const v = p.variants[Number(card.dataset.sel)];
      if (!v || !v.available || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      try {
        const { root } = await this.postAdd(v);
        window.location = `${root}checkout`;
      } catch (e) {
        btn.removeAttribute('aria-busy');
        btn.textContent = e.message || this.s.error;
        setTimeout(() => this.syncCard(card, p), 3000);
      }
    }
  }

  let viewer = null;

  /* ───────────────────────── Daireler ───────────────────────── */
  class KremiUgcStories extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.bubbles = Array.from(this.querySelectorAll('.kremi-stories__bubble'));
      this.stories = readJson(this, '[data-story-data]', []);
      this.strings = readJson(this, '[data-story-strings]', {});
      this.bubbles.forEach((bubble) =>
        bubble.addEventListener('click', () => {
          viewer = viewer || new StoryViewer();
          viewer.open(this, this.stories, this.strings, Number(bubble.dataset.storyIndex) || 0);
        }),
      );
      this.setupArrows();
      const videos = this.bubbles.map((b) => b.querySelector('video')).filter(Boolean);
      if (!('IntersectionObserver' in window)) {
        videos.forEach((v) => this.start(v));
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.dataset.visible = entry.isIntersecting ? '1' : '';
            if (entry.isIntersecting && !this.paused) this.start(entry.target);
            else entry.target.pause();
          });
        },
        { threshold: 0.25 },
      );
      videos.forEach((v) => this.observer.observe(v));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    /** Kaydırma okları: yalnız taşma varken; uçlarda ilgili ok gizlenir (10-03). */
    setupArrows() {
      const row = this.querySelector('.kremi-stories__row');
      const track = this.querySelector('.kremi-stories__track');
      const prev = this.querySelector('[data-scroll="-1"]');
      const next = this.querySelector('[data-scroll="1"]');
      if (!row || !prev || !next) return;
      const rtl = getComputedStyle(row).direction === 'rtl';
      const update = () => {
        const max = row.scrollWidth - row.clientWidth;
        const pos = Math.abs(row.scrollLeft);
        prev.hidden = pos <= 2;
        next.hidden = max <= 2 || pos >= max - 2;
        track.classList.toggle('has-prev', !prev.hidden);
        track.classList.toggle('has-next', !next.hidden);
      };
      [prev, next].forEach((btn) =>
        btn.addEventListener('click', () => {
          const dir = Number(btn.dataset.scroll) * (rtl ? -1 : 1);
          row.scrollBy({ left: dir * Math.max(row.clientWidth * 0.8, 120), behavior: 'smooth' });
        }),
      );
      row.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(row);
      }
      update();
    }

    pauseBubbles() {
      this.paused = true;
      this.bubbles.forEach((b) => b.querySelector('video')?.pause());
    }

    resumeBubbles() {
      this.paused = false;
      this.bubbles.forEach((b) => {
        const v = b.querySelector('video');
        if (v && v.dataset.visible) this.start(v);
      });
    }

    /** Kaynağı (bir kez) seç ve sessiz başlat. */
    load(video) {
      if (video.getAttribute('src')) return;
      let sources = [];
      try {
        sources = JSON.parse(video.dataset.storySources || '[]');
      } catch (e) {
        sources = [];
      }
      sources = sources.filter((x) => x && x.u).sort((a, b) => a.w - b.w);
      if (!sources.length) return;
      const needed = Math.ceil((video.getBoundingClientRect().width || 84) * (window.devicePixelRatio || 1));
      const pick = sources.find((x) => x.w >= needed) || sources[sources.length - 1];
      video.src = pick.u;
    }

    start(video) {
      this.load(video);
      video.muted = true;
      video.play().catch(() => {});
    }
  }

  window.customElements.define('kremi-ugc-stories', KremiUgcStories);
})();
